import styled from '@emotion/styled';
import { Select, TabV2, TextBox, Tooltip, Typography } from 'src/components-dummy';

export const TabWrapper = styled.div`
  display: flex;
  padding: 0 20px;
`;

export const StyledTab = styled(TabV2)<{ isActive: boolean }>`
  flex: 1;
  background-color: ${({ isActive, theme }) =>
    isActive ? 'transparent' : theme.palette.custom['gray-80']};

  border: ${({ isActive, theme }) =>
    isActive ? 'none' : `1px solid ${theme.palette.custom['gray-60']}`};

  border-top: ${({ theme }) => `1px solid ${theme.palette.custom['gray-60']}}`};

  &.MuiButtonBase-root.MuiTab-root.MuiTab-textColorInherit {
    color: black;
    opacity: unset;
    font-size: 14px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.palette.custom['gray-80']};
  background: ${({ theme }) => theme.palette.custom['gray-120']};
  padding: 24px 16px;
  gap: 16px;
`;

export const LabelStyled = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
`;

export const TooltipStyled = styled(Tooltip)`
  .syte-popup-content {
    max-width: 150px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
`;

export const TextStyled = styled(Typography)`
  font-size: 12px;
  margin-bottom: 4px;
  max-width: 95%;
  display: block;
`;

export const SelectStyled = styled(Select)`
  .MuiInputBase-input {
    background-color: ${({ theme }) => theme.palette.common.white};
    border: solid 1px ${({ theme }) => theme.palette.custom['gray-50']};
  }
`;

export const TextBoxStyled = styled(TextBox)`
  .input-base-wrapper {
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;
